var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{model:{value:(_vm.isIncompleteDataShown),callback:function ($$v) {_vm.isIncompleteDataShown=$$v},expression:"isIncompleteDataShown"}},[_vm._v("\n  Include incomplete data periods\n")])}
var staticRenderFns = []

export { render, staticRenderFns }